// @flow
import React from 'react'
import styles from './SearchResult.css'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import formatters from 'lib/formatters'
import { getStatusClassName, sortMergedBeneficiaries } from './utils'

type Props = {
  contact: any,
}

export function SearchResultItem({ contact }: Props) {
  const { mergedBeneficiaries } = contact
  const sortedBeneficiaries = mergedBeneficiaries
    ? [...mergedBeneficiaries].sort(sortMergedBeneficiaries)
    : mergedBeneficiaries
  const emailsFromList = (contact.emails || []).map((item) => item.email).filter(Boolean)
  const contactEmails = contact.email
    ? Array.from(new Set([contact.email, ...emailsFromList]))
    : emailsFromList

  function renderLink(number, role) {
    if (role == 'Potential Client') {
      return (
        <Link
          className={styles.contactAccountNumber}
          to={`/potential_clients/edit/${number}`}
        >
          PC{number}
        </Link>
      )
    } else {
      return (
        <Link
          className={styles.contactAccountNumber}
          to={`/accounts/${number}`}
        >
          {number}
        </Link>
      )
    }
  }

  return (
    <div className={styles.contact}>
      <div className={styles.contactHeader}>
        <div className={styles.contactHeaderRow}>
          <Link
            to={`/contacts/${contact.id}/edit`}
            className={styles.refEdit}
          />
          <label className={styles.contactHeaderRow__name}>
            {contact.name}
            {contact.has_open_ticket && (
              <FontAwesomeIcon
                className={styles.ticketIcon}
                icon={'ticket-alt'}
                transform={{ rotate: -45 }}
              />
            )}
          </label>
          <span>{`${(sortedBeneficiaries || []).length} Accounts`}</span>
        </div>

        <div className={styles.contactHeaderRow}>
          <label>Email</label>
          {contactEmails.length > 0 ? (
            <span>
              {contactEmails.map((email, index) => (
                <React.Fragment key={email}>
                  <a href={`mailto:${email}`}>{email}</a>
                  {index < contactEmails.length - 1 && (index + 1) % 2 === 0 ? <br /> : null}
                  {index < contactEmails.length - 1 && (index + 1) % 2 !== 0 ? ', ' : ''}
                </React.Fragment>
              ))}
            </span>
          ) : (
            <span>N/A</span>
          )}
        </div>

        <div className={styles.contactHeaderRow}>
          <label>Cell Number</label>
          <span>
            {contact.phone_numbers.cell_phone
              ? formatters.phone(contact.phone_numbers.cell_phone)
              : 'N/A'}
          </span>
        </div>

        <div className={styles.contactHeaderRow}>
          <label>Day Number</label>
          <span>
            {contact.phone_numbers.day_phone
              ? formatters.phone(contact.phone_numbers.day_phone)
              : 'N/A'}
          </span>
        </div>
      </div>
      {sortedBeneficiaries && sortedBeneficiaries.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>Account</th>
              <th>Role</th>
              <th>Beneficiary</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {sortedBeneficiaries.map(({ number, beneficiary, role, status }, index) => (
              <tr key={`${number} ${index}`}>
                <td>
                  <div className={styles.accountCell}>
                    {renderLink(number, role)}
                    {status && (
                      <span className={`${styles.statusBadge} ${getStatusClassName(status)}`}>
                        {formatters.legibleAccountStatus(status)}
                      </span>
                    )}
                  </div>
                </td>
                <td>{role}</td>
                <td>
                  <Link to={`/beneficiaries/show/${beneficiary.id}`}>
                    {beneficiary.name}
                  </Link>
                </td>
                <td>
                  {beneficiary.has_open_ticket && (
                    <FontAwesomeIcon
                      className={styles.ticketIcon}
                      icon={'ticket-alt'}
                      transform={{ rotate: -45 }}
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
